const getReadOnlyUrlPart = (entity) =>
  `${process.env.REACT_APP_MAIN_SITE_URL}/${entity}/`;

export default getReadOnlyUrlPart;
